import {
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Box,
  Typography,
  Divider,
} from '@mui/material';
import DashboardIcon from '@mui/icons-material/SpaceDashboard';
import FolderIcon from '@mui/icons-material/FolderSpecial';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import ChecklistIcon from '@mui/icons-material/Checklist';
import GroupIcon from '@mui/icons-material/Group';
import FlagIcon from '@mui/icons-material/Flag';
import PhoneIcon from '@mui/icons-material/PhoneInTalk';
import ForumIcon from '@mui/icons-material/Forum';
import ArticleIcon from '@mui/icons-material/Article';
import DescriptionIcon from '@mui/icons-material/Description';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { NavLink } from 'react-router-dom';

interface Props {
  drawerWidth: number;
  open: boolean;
}

const items = [
  { to: '/', label: 'Dashboard', icon: <DashboardIcon />, end: true },
  { to: '/projects', label: 'Projects', icon: <FolderIcon /> },
  { to: '/sprints', label: 'Sprints', icon: <DirectionsRunIcon /> },
  { to: '/tasks', label: 'Tasks', icon: <ChecklistIcon /> },
  { to: '/assignees', label: 'Assignees', icon: <GroupIcon /> },
  { to: '/daily-goals', label: 'Daily Goals', icon: <FlagIcon /> },
  { to: '/call-topics', label: 'Call Topics', icon: <PhoneIcon /> },
  { to: '/refinements', label: 'Refinements', icon: <ForumIcon /> },
  { to: '/scope', label: 'Sprint Scope', icon: <ArticleIcon /> },
  { to: '/report', label: 'Reports', icon: <DescriptionIcon /> },
  { to: '/import', label: 'CSV Import', icon: <UploadFileIcon /> },
];

export default function Sidebar({ drawerWidth, open }: Props) {
  return (
    <Drawer
      variant="persistent"
      open={open}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
          borderRight: (t) => `1px solid ${t.palette.divider}`,
        },
      }}
    >
      <Toolbar sx={{ px: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box
            sx={{
              width: 28,
              height: 28,
              borderRadius: 1.5,
              background: (t) =>
                `linear-gradient(135deg, ${t.palette.primary.main}, ${t.palette.secondary.main})`,
            }}
          />
          <Typography variant="h6" fontWeight={700}>
            Sprint
          </Typography>
        </Box>
      </Toolbar>
      <Divider />
      <List sx={{ px: 1, py: 1 }}>
        {items.map((item) => (
          <ListItemButton
            key={item.to}
            component={NavLink}
            to={item.to}
            end={item.end}
            sx={{
              borderRadius: 1.5,
              mb: 0.5,
              '&.active': {
                bgcolor: 'action.selected',
                color: 'primary.main',
                '& .MuiListItemIcon-root': { color: 'primary.main' },
              },
            }}
          >
            <ListItemIcon sx={{ minWidth: 36 }}>{item.icon}</ListItemIcon>
            <ListItemText primary={item.label} />
          </ListItemButton>
        ))}
      </List>
    </Drawer>
  );
}
